import { useTransferSectionMutation } from 'shared/hooks/queries/use-transfer-section-mutation';

export const useTransferSection = () => {
  const { mutate } = useTransferSectionMutation();

  return mutate;
};
